// extracted by mini-css-extract-plugin
module.exports = {"form":"EmailInput_form__GFJiL","success":"EmailInput_success__d6eau","icon":"EmailInput_icon__PmkRm"};